export default "__VITE_ASSET__BTZn6pW7__"